export default {
  typography: {
    fontFamily: 'inherit',
    fontSize: 'inherit',
  },
};
